"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTextareaToAddress = exports.convertDateToCheckYYYYMMDD = exports.getCurrentCheckCompanyId = exports.isCheckError = exports.US_STATES = void 0;
const contracts_1 = require("./contracts");
exports.US_STATES = [
    { code: "AL", name: "Alabama" },
    { code: "AK", name: "Alaska" },
    { code: "AZ", name: "Arizona" },
    { code: "AR", name: "Arkansas" },
    { code: "CA", name: "California" },
    { code: "CO", name: "Colorado" },
    { code: "CT", name: "Connecticut" },
    { code: "DE", name: "Delaware" },
    { code: "FL", name: "Florida" },
    { code: "GA", name: "Georgia" },
    { code: "HI", name: "Hawaii" },
    { code: "ID", name: "Idaho" },
    { code: "IL", name: "Illinois" },
    { code: "IN", name: "Indiana" },
    { code: "IA", name: "Iowa" },
    { code: "KS", name: "Kansas" },
    { code: "KY", name: "Kentucky" },
    { code: "LA", name: "Louisiana" },
    { code: "ME", name: "Maine" },
    { code: "MD", name: "Maryland" },
    { code: "MA", name: "Massachusetts" },
    { code: "MI", name: "Michigan" },
    { code: "MN", name: "Minnesota" },
    { code: "MS", name: "Mississippi" },
    { code: "MO", name: "Missouri" },
    { code: "MT", name: "Montana" },
    { code: "NE", name: "Nebraska" },
    { code: "NV", name: "Nevada" },
    { code: "NH", name: "New Hampshire" },
    { code: "NJ", name: "New Jersey" },
    { code: "NM", name: "New Mexico" },
    { code: "NY", name: "New York" },
    { code: "NC", name: "North Carolina" },
    { code: "ND", name: "North Dakota" },
    { code: "OH", name: "Ohio" },
    { code: "OK", name: "Oklahoma" },
    { code: "OR", name: "Oregon" },
    { code: "PA", name: "Pennsylvania" },
    { code: "RI", name: "Rhode Island" },
    { code: "SC", name: "South Carolina" },
    { code: "SD", name: "South Dakota" },
    { code: "TN", name: "Tennessee" },
    { code: "TX", name: "Texas" },
    { code: "UT", name: "Utah" },
    { code: "VT", name: "Vermont" },
    { code: "VA", name: "Virginia" },
    { code: "WA", name: "Washington" },
    { code: "WV", name: "West Virginia" },
    { code: "WI", name: "Wisconsin" },
    { code: "WY", name: "Wyoming" },
];
const isCheckError = (apiResponse) => {
    return apiResponse.error === contracts_1.RequestErrorCode.CHECK_ERROR || !!apiResponse.checkResponseError;
};
exports.isCheckError = isCheckError;
const getCurrentCheckCompanyId = (storeUser) => {
    var _a, _b;
    if (!(storeUser === null || storeUser === void 0 ? void 0 : storeUser.currentWorkspaceId))
        return null;
    const workspace = storeUser.workspaces.find((w) => w.id === storeUser.currentWorkspaceId);
    return ((_b = (_a = storeUser.workspaces.find((w) => w.id === storeUser.currentWorkspaceId)) === null || _a === void 0 ? void 0 : _a.company) === null || _b === void 0 ? void 0 : _b.checkCompanyId) || null;
};
exports.getCurrentCheckCompanyId = getCurrentCheckCompanyId;
const convertDateToCheckYYYYMMDD = (date) => {
    return date.toISOString().split('T')[0];
};
exports.convertDateToCheckYYYYMMDD = convertDateToCheckYYYYMMDD;
// this should be deprecated and replace with a custom property type that is an Address
const convertTextareaToAddress = (addressBlock) => {
    // 1. Split by newline to separate the street from the rest
    const lines = addressBlock.split('\n');
    if (lines.length < 2)
        return {
            line1: '',
            line2: '',
            postal_code: '',
            city: '',
            state: '',
            country: 'US',
        };
    const street = lines[0].trim();
    const cityStateZip = lines[1].trim();
    // 2. Use Regex to capture: City (anything before comma), State (2 caps), Zip (5 digits)
    const regex = /^(.+?),\s*([A-Za-z]{2})\s+(\d{5})$/;
    const match = cityStateZip.match(regex);
    if (match) {
        const [_, city, state, zip] = match;
        return {
            line1: street,
            line2: '',
            postal_code: zip,
            city: city,
            state: state.toUpperCase(),
            country: 'US',
        };
    }
    return {
        line1: '',
        line2: '',
        postal_code: '',
        city: '',
        state: '',
        country: 'US',
    };
};
exports.convertTextareaToAddress = convertTextareaToAddress;
// export const getCheckCompanyStatus = (checkCompany: CheckCompany) => {
//   return (checkCompany.onboard && checkCompany.onboard.status === "completed") ? "onboarded" : 
//       checkOnboardLink ? "onboarding" : (checkSignatories && checkSignatories.length > 0) ? "launch" : "signatories";
// };
